import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Skyeair-FMS';
  loading = false;
  userSessionService: any;

  // private primengConfig: PrimeNGConfig
  constructor( private router: Router, private primengConfig: PrimeNGConfig) {
  }
  // constructor(private router: Router,updates: SwUpdate) {
  //   updates.available.subscribe(event => {
  //     if (promptUser(event)) {
  //         updates.activateUpdate().then(() => document.location.reload());
  //     }
  //   });
  // }
  
  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }

  @HostListener("window:onbeforeunload", ["$event"])
  clearLocalStorage(event) {
    localStorage.clear();
  }
}



